module.exports = __webpack_public_path__ + "static/media/6.a79e1784.png";